import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'

import ActivityWrapupSkeleton from './ActivityWrapupSkeleton'
import WrapupCardWriting from './subcomponents/WrapupCardWriting/WrapupCardWriting'

const ActivityWrapupWriting = ({
  vocabularyGroups,
  correctionsRequested,
  ...rest
}) => {
  return (
    <ActivityWrapupSkeleton
      titleSection={t('You completed a writing practice entry!')}
      vocabularySection={
        <WrapupCardWriting
          vocabularyGroups={vocabularyGroups}
          correctionsRequested={correctionsRequested}
        />
      }
      {...rest}
    />
  )
}

ActivityWrapupWriting.propTypes = {
  correctionsRequested: PropTypes.bool,
  vocabularyGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default ActivityWrapupWriting
